export const generateId = () => Math.random().toString(36).slice(2, 9);

export const formatDate = (dateString) => {
  if (!dateString) return '';
  return new Date(dateString).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
};

export const isOverdue = (dateString) => {
  if (!dateString) return false;
  return new Date(dateString) < new Date().setHours(0, 0, 0, 0);
};

export const isSoon = (dateString) => {
  if (!dateString || isOverdue(dateString)) return false;
  const daysDiff = (new Date(dateString) - new Date().setHours(0, 0, 0, 0)) / 86400000;
  return daysDiff <= 2;
};

export const addDays = (days) => {
  const date = new Date();
  date.setDate(date.getDate() + days);
  return date.toISOString().split('T')[0];
};
